// Volatility (Mars): every constellation scores more, but a small one
// scores nothing at all (zeroed in the standings).
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const volatility: AlignmentDef = {
  id: 'volatility',
  planet: 'mars',
  name: 'Volatility',
  text: () => `Every constellation scores +${N.volatilityPercent}%. A constellation of ${N.volatilityStars} stars or fewer scores 0.`,
  wordPercent: () => N.volatilityPercent,
  standing: (entries) => entries.filter((e) => e.ctx.nodes.length <= N.volatilityStars).map((e) => ({ index: e.index, zero: true })),
};
